export default __webpack_public_path__ + "media/images/header-cybre-colour-28ba2fcadc07069fa526ed1d894dd874.jpg";